module.exports = __webpack_public_path__ + "img/esaminatore-vini.4af5d57d.jpg";